import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import dayjs from "dayjs";
import { truncate } from "lodash";

class VehicleOtherInfoStore {
  offlineDataNewObj = [];
  trackingDataNewObj = [];
  histTrackingClickPolylineObj = [];
  timeWisePolylineArray = [];
  offlineData = [];
  idleAndStopPointsArray = [];
  vehiclesHistData = [];
  vehicleSummaryData = [];
  vehiclesTriggerData = [];
  vehicleTrackingData = [];
  fuelRefillData = [];
  graphData = [];
  fuelRefillLatLong = [];

  totalCount = null;
  total = 0;

  pgcount = 1;
  offset = 0;
  postData = {};

  daySummaryObj = {};
  driverPerformanceData = {};

  statusData = {};
  obdData = []
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      vehiclesHistData: observable,
      offlineDataNewObj: observable,
      vehicleSummaryData: observable,
      offlineData: observable,
      vehiclesTriggerData: observable,
      trackingDataNewObj: observable,
      histTrackingClickPolylineObj: observable,
      idleAndStopPointsArray: observable,
      timeWisePolylineArray: observable,
      fuelRefillData: observable,
      pgcount: observable,
      offset: observable,
      vehicleTrackingData: observable,
      graphData: observable,
      fuelRefillLatLong: observable,
      driverPerformanceData: observable,
      daySummaryObj: observable,
      statusData: observable,
      obdData: observable,
      handleOfflineData: action,
      setOfflineData: action,
      getHistoryTrackingData: action,
      getHistoryTrackingData2: action,
      getVehicleHistoryData: action,
      getVehicleRuleTriggerData: action,
      getFuelRefillData: action,
      daySummary: action,
      getDriverPerformance: action,
      getStatusWiseData: action,
      getVehicleTripData: action,
      getObdData: action,
      downloadTempGraphReport: action,
      downloadTempGraphReportTrip: action,
    });

    this.rootStore = rootStore;
  }

  async getVehicleHistoryData({ companyId, vehicleId, fromDate, toDate }) {
    this.loading = true;
    if (config.pythonReport === 1) {
      var postData = {
        companyId: companyId,
        vehicleId: [vehicleId],
        fromDate: dayjs(fromDate).format("YYYY-MM-DD"),
        toDate: dayjs(toDate).format("YYYY-MM-DD"),
        offset: 0,
        limit: 50,
        page: 1,
        last_record_timestamp: "",
        remaning_vehicleId: "",
        dateType: 1,
        pollmin: 90,
        is_fulldaysumary: true,
      };
      var response = await postApi
        .getClient("report")
        .post("/fleet_report/fleetDaySummary", postData);
      this.vehiclesHistData = response.data.data;
      this.vehicleSummaryData = response?.data?.data?.daysummary;
      this.vehicleFullSummary = response?.data?.data?.fulldaySummary;
    } else {
      var postData = {
        companyId: companyId,
        vehicleId: vehicleId,
        fromDate: fromDate,
        toDate: toDate,
        offset: -1,
        limit: 50,
      };

      const base64Input = await base64_encode(JSON.stringify(postData));

      var response = await postApi
        .getClient()
        .post(
          "index.php?c=dashboard&a=getVehicleHistory",
          "postData=" + base64Input
        );

      this.vehiclesHistData = response.data.data;
      this.vehicleSummaryData = response.data.data.summaryData;
      this.vehicleTripData = response.data.data.tripData;
    }
    this.loading = false;

    return response.data.data;
  }

  groupTripsByDate(tripData) {
    const grouped = {};

    tripData.forEach((item) => {
      const date = item?.startTime.split(" ")[0];

      if (!grouped[date]) {
        grouped[date] = [];
      }
      grouped[date].push(item);
    });

    return grouped;
  }
  async getVehicleTripData({ companyId, vehicleId, fromDate, toDate }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      travelInt: 0,
      stopInt: 0,
      idleInt: 0,
      offset: 0,
      limit: 50,
      page: 1,
      last_record_timestamp: "",
      remaning_vehicleId: "",
      livetracking: true,
    };

    var response = await postApi
      .getClient("report")
      .post("/tracking_report/trip", postData);
    // this.vehiclesHistData = response.data.data;
    // this.vehicleTripData = response?.data?.data?.tripreport;
    const groupedTrips = this.groupTripsByDate(
      response?.data?.data?.tripreport
    );
    this.vehicleTripData = groupedTrips;
    this.loading = false;
  }

  async setOfflineData(data) {
    // this.vehicleId = data.vehicleId;
    if (data.resetOffset === 1) {
      this.offset = 0;
    }
    var postData = {
      ...data,
      limit: 500,
      page: this.pgcount,
      offset: this.offset,
      SelRoutOption: "3",
      TripEventdata: 1,
      tableName: "mt90",
      isLiveTracking: true,
    };
    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("/liveTracking/getHistoryTrackingDataCH", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=offlinedata", "postData=" + base64Input);
    }
    this.postData = data;
    let totalCount = response?.data?.data?.totalcount;
    this.offlineData = response?.data?.data;

    // this.historyTrackingTableData = this.offlineDataNewObj

    if (this.totalCount === null) {
      this.totalCount = totalCount;
    }

    if (
      this.totalCount >= 10 ||
      (this.totalCount < 10 && this.totalCount >= 0)
    ) {
      if (await this.offlineData.vehicleposition) {
        await this.offlineData.vehicleposition?.forEach((val) => {
          // this.offlineLatLongArray.push(val);
          this.offlineDataNewObj.push([val.latitude, val.longitude]);
        });

        await this.handleOfflineData();
      }
    } else if (this.totalCount === 0) {
      console.log("end");
    }
  }

  async handleOfflineData() {
    this.totalCount = this.totalCount - 500;
    this.pgcount = ++this.pgcount;
    this.offset = this.offset + 500;
    await this.setOfflineData(this.postData);
  }

  async getFuelRefillData({ companyId, vehicleId, fromDate, toDate }) {
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=fuelrefill", "postData=" + base64Input);

    this.fuelRefillData = response.data.data.fuelrefill.fuelrefill;

    // if (this.fuelRefillData) {
    //   Object.keys(this.fuelRefillData).map((e, i) => {
    //     let sub = {
    //       name: this.fuelRefillData[i].timestamp,
    //       uv: parseFloat(this.fuelRefillData[i].refillfuellevel),
    //       // pv: parseFloat(this.fuelRefillData[i].refillfuel),
    //     };
    //     let sub2 = [
    //       this.fuelRefillData[i].latitude,
    //       this.fuelRefillData[i].longitude,
    //     ];
    //     this.graphData.push(sub);
    //     this.fuelRefillLatLong.push(sub2);
    //   });
    // }

    return response?.data?.data?.fuelrefill;
  }

  async getHistoryTrackingData({ companyId, vehicleId, fromDate, toDate }) {
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      SelRoutOption: 3,
      TripEventdata: 1,
      tableName: "mt90",
    };
    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("/liveTracking/getHistoryTrackingDataCH", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicletracking&a=getHistoryTrackingData",
          "postData=" + base64Input
        );
    }
    this.vehicleTrackingData = response.data.data.vehicleposition;

    if (this.vehicleTrackingData) {
      await this.vehicleTrackingData?.forEach((val) => {
        // this.offlineLatLongArray.push(val);
        this.histTrackingClickPolylineObj.push([val.latitude, val.longitude]);
      });
      this.offlineDataNewObj = this.histTrackingClickPolylineObj;
    }
    return response.data.data;
  }

  async getHistoryTrackingData2({ companyId, vehicleId, fromDate, toDate }) {
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      SelRoutOption: 3,
      TripEventdata: 1,
      tableName: "mt90",
    };
    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("/liveTracking/getHistoryTrackingDataCH", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicletracking&a=getHistoryTrackingData",
          "postData=" + base64Input
        );
    }
    this.vehicleTrackingData = response.data.data.vehicleposition;
    if (this.vehicleTrackingData) {
      await this.vehicleTrackingData?.forEach((val) => {
        // this.offlineLatLongArray.push(val);
        if (
          val.activity === "Idle" ||
          (Number(val.acc === 1) && Number(val.speed) === 0)
        ) {
          // this.drawIdleAndStopIcon(val, "Orange");
          this.idleAndStopPointsArray.push({
            vehicleObj: val,
            activity: "Orange",
          });
        } else if (val.activity === "Stop" || Number(val.acc) === 0) {
          // this.drawIdleAndStopIcon(val, "Red");
          this.idleAndStopPointsArray.push({
            vehicleObj: val,
            activity: "Red",
          });
        }
        if (val.latitude && val.longitude) {
          this.timeWisePolylineArray.push([val.latitude, val.longitude]);
        }
      });
    }
    return this.vehicleTrackingData.length;
  }

  async getVehicleRuleTriggerData({ companyId, vehicleId, fromDate, toDate }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      ruleSelectorId: [
        "1",
        "2",
        "5",
        "6",
        "4",
        "7",
        "10",
        "8",
        "15",
        "16",
        "18",
        "23",
        "25",
        "24",
        "26",
        "27",
        "28",
        "29",
        "30",
      ],
      vehicleId: [vehicleId],
      fromDate: fromDate,
      toDate: toDate,
      offset: 0,
      limit: 15,
      page: 1,
    };
    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("/ruleTrigger/ruleTrigger", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=ruletrigger", "postData=" + base64Input);
    }
    this.vehiclesTriggerData = response.data.data.ruletrigger;
    this.ruleCount = response.data.data.TotalCount;
    this.loading = false;
    return response.data.data;
  }

  async getDriverPerformance(data) {
    if (config.pythonReport === 1) {
      this.loading = true;

      var postData = {
        companyId: data.companyId,
        driverId: [data.driverId],
        fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
        toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        offset: 0,
        limit: 50,
        page: 1,
        last_record_timestamp: "",
        remaning_driverId: "",
        liveTracking: true,
      };
      var response = await postApi
        .getClient("report")
        .post("/driver_report/driverperformance", postData);

      this.driverPerformanceData = response.data?.data?.driverperformance[0];
      this.loading = false;

      return response?.data?.data?.driverperformance[0];
    } else {
      this.loading = true;

      var postData = data;
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicletracking&a=getDriverPerformance",
          "postData=" + base64Input
        );
      this.driverPerformanceData = response.data?.data;
      this.loading = false;

      return response?.data?.data;
    }
  }

  async daySummary({ currentDate, companyId, vehicleId }) {
    this.loading = true;
    var postData = {
      pollmin: 90,
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: currentDate,
      toDate: currentDate,
      offset: 0,
      limit: 50,
      dateType: 1,
      liveTracking: true,
    };
    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("/fleet_report/fleetDaySummary", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=daysummary", "postData=" + base64Input);
    }

    this.daySummaryObj = response.data?.data?.daysummary[0];

    this.loading = false;

    return response?.data?.data?.daysummary[0];
  }

  async getStatusWiseData({ vehicleId, companyId }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
    };
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/liveTracking/getStatusWiseVehiclesData", {
        params: postData,
      });

    this.statusData = response?.data?.data?.statusWiseData[0];
    this.loading = false;
    return response?.data?.data?.statusWiseData[0];
  }

  async getObdData(vehicleId) {
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/liveTracking/getObdValues", {
        params: {
          vehicleId: vehicleId
        }
      });

    this.obdData = response?.data?.data
    return response?.data?.data
  }

  async downloadTempGraphReport({ companyId, vehicleId, fromDate, toDate, interval }) {
    try {
      const response = await postApi.getClient().get(
        "index.php?c=vehicletracking&a=livetrackTempGraphpdf",
        {
          params: {
            cid: companyId,
            vid: vehicleId,
            fD: fromDate,
            tD: toDate,
            interval,
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `temp_graph_report.pdf`;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error downloading temp graph report:", error);
      throw error;
    }
  }

  async downloadTempGraphReportTrip({ companyId, vehicleId, fromDate, toDate, interval }) {
    try {
      const response = await postApi.getClient().get(
        "index.php?c=vehicletracking&a=livetrackTempGraphpdf_Trips",
        {
          params: {
            cid: companyId,
            vid: vehicleId,
            fD: fromDate,
            tD: toDate,
            interval,
          },
          responseType: "blob",
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `temp_graph_report.pdf`;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error downloading temp graph report:", error);
      throw error;
    }
  }
}

export default VehicleOtherInfoStore;
